import { render, staticRenderFns } from "./SpecialOffer.vue?vue&type=template&id=a0b46b46&lang=pug"
import script from "./SpecialOffer.vue?vue&type=script&lang=js"
export * from "./SpecialOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports